import { render, staticRenderFns } from "./Login2.vue?vue&type=template&id=4b370918"
import script from "./Login2.vue?vue&type=script&lang=ts"
export * from "./Login2.vue?vue&type=script&lang=ts"
import style0 from "./Login2.vue?vue&type=style&index=0&id=4b370918&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports